import {
  FETCH_SYNC_JOB_DETAILS,
  SUBMIT_SYNC_CATEGORIES,
  CLEAR_SYNC_JOB_STATE,
  SyncJobDetails,
  CategoryLatestSync,
  FETCH_CATEGORY_LATEST_SYNC,
  RESET_SYNC_CATEGORY_DETAILS,
} from "./SyncCategoriesTypes";

export interface SyncCategoriesState {
  loading: boolean;
  syncJobId: string;
  syncJobDetails: SyncJobDetails | null;
  categoryLatestSync: CategoryLatestSync;
}

const initialState: SyncCategoriesState = {
  loading: false,
  syncJobId: "",
  syncJobDetails: {
    syncJobId: "",
    source: {
      storeId: "",
      catalogId: "",
      categoryId: "",
    },
    targets: [],
    options: {
      addProducts: false,
      removeProducts: false,
    },
    status: "",
    statusAt: "",
    error: {
      reason: "",
      message: "",
    },
    triggeredBy: "",
    createdAt: "",
    updatedAt: "",
  },
  categoryLatestSync: {
    syncJobId: "",
    source: {
      storeId: "",
      catalogId: "",
      categoryId: "",
    },
    targets: [],
    options: {
      addProducts: false,
      removeProducts: false,
    },
    status: "",
    statusAt: "",
    error: {
      reason: "",
      message: "",
    },
    triggeredBy: "",
    createdAt: "",
    updatedAt: "",
  },
};

export const SyncCategoriesReducer = (
  state: SyncCategoriesState = initialState,
  action: any,
): SyncCategoriesState => {
  switch (action.type) {
    case SUBMIT_SYNC_CATEGORIES.REQUEST:
      return {
        ...state,
        loading: true,
        syncJobDetails: null,
        syncJobId: "",
      };
    case SUBMIT_SYNC_CATEGORIES.SUCCESS:
      const { syncJobId } = action.payload;
      return {
        ...state,
        loading: false,
        syncJobId,
      };
    case SUBMIT_SYNC_CATEGORIES.FAILURE:
      return {
        ...state,
        loading: false,
      };
    case FETCH_SYNC_JOB_DETAILS.REQUEST:
      return {
        ...state,
        loading: true,
      };
    case FETCH_SYNC_JOB_DETAILS.SUCCESS:
      return {
        ...state,
        loading: false,
        syncJobDetails: action.payload,
        categoryLatestSync: action.payload,
      };
    case FETCH_SYNC_JOB_DETAILS.FAILURE:
      return {
        ...state,
        loading: false,
        syncJobDetails: null,
      };
    case CLEAR_SYNC_JOB_STATE:
      return {
        ...state,
        syncJobId: "",
      };
    case FETCH_CATEGORY_LATEST_SYNC.REQUEST:
    case FETCH_CATEGORY_LATEST_SYNC.FAILURE:
      return {
        ...state,
        categoryLatestSync: {
          syncJobId: "",
          source: {
            storeId: "",
            catalogId: "",
            categoryId: "",
          },
          targets: [],
          options: {
            addProducts: false,
            removeProducts: false,
          },
          status: "",
          statusAt: "",
          error: {
            reason: "",
            message: "",
          },
          triggeredBy: "",
          createdAt: "",
          updatedAt: "",
        },
      };
    case FETCH_CATEGORY_LATEST_SYNC.SUCCESS:
      return {
        ...state,
        categoryLatestSync: action.payload,
      };
    case RESET_SYNC_CATEGORY_DETAILS:
      return {
        ...state,
        categoryLatestSync: {
          syncJobId: "",
          source: {
            storeId: "",
            catalogId: "",
            categoryId: "",
          },
          targets: [],
          options: {
            addProducts: false,
            removeProducts: false,
          },
          status: "",
          statusAt: "",
          error: {
            reason: "",
            message: "",
          },
          triggeredBy: "",
          createdAt: "",
          updatedAt: "",
        },
      };
    default:
      return state;
  }
};
